import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=00338969&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=00338969&prod&scoped=true&lang=css"
import style1 from "./Settings.vue?vue&type=style&index=1&id=00338969&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00338969",
  null
  
)

export default component.exports